// src/contexts/AktionContext.js
import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import { fetchWithRetry } from '../utils/fetchWithRetry';

export const AktionContext = createContext();

export const AktionProvider = ({ children }) => {
  const [aktionen, setAktionen] = useState([]);
  const [loadingAktionen, setLoadingAktionen] = useState(true);
  const [errorAktionen, setErrorAktionen] = useState(null);

  const AKTIONEN_API_URL =
    'https://admin.thirsty-shtern.91-151-16-181.plesk.page/items/Werbung?fields=*.*&filter[status][_eq]=published';

  useEffect(() => {
    const ac = new AbortController();
    const fetchAktionen = async () => {
      setLoadingAktionen(true); setErrorAktionen(null);
      try {
        const res = await fetchWithRetry(
          () => axios.get(AKTIONEN_API_URL, { signal: ac.signal }),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );
        setAktionen(res?.data?.data ?? []);
      } catch (e) {
        if (!ac.signal.aborted) setErrorAktionen('Fehler beim Laden der Aktionen');
      } finally {
        if (!ac.signal.aborted) setLoadingAktionen(false);
      }
    };
    fetchAktionen();
    /* return () => ac.abort(); */
  }, []);

  return (
    <AktionContext.Provider value={{ aktionen, loadingAktionen, errorAktionen }}>
      {children}
    </AktionContext.Provider>
  );
};
